import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=588690d7&scoped=true"
var script = {}
import style0 from "./HeroHeader.vue?vue&type=style&index=0&id=588690d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588690d7",
  null
  
)

export default component.exports